import Cookies from 'js-cookie';
import { ACCESS_TOKEN_KEY } from 'src/constants/auth';
import { ApiPath } from 'src/enums/apiPath';
import { apiRequest } from 'src/utils/api';
import { LoginFormI } from 'src/models/auth';
import { RoutePath } from 'src/enums/routePath';

export const login = async (payload: LoginFormI) => {
  const res = await apiRequest.post({
    url: ApiPath.LOGIN,
    data: payload
  });
  const accessToken = res?.data?.data?.token;
  // const decoded = jwtDecode(accessToken);
  // const expiredDate = timestampToDate(Number(decoded?.exp));

  if (!!accessToken) {
    Cookies.set(ACCESS_TOKEN_KEY, accessToken);
  }

  return res;
};

export const logout = () => {
  Cookies.remove(ACCESS_TOKEN_KEY);
  window.location.replace(RoutePath.LOGIN);
};
